<div class="add_or_delete_container flex_align_center">
  <div class="reduce_and_add_container flex_align_center" [ngClass]="{basket_style: type === AddAndReduceStatusEnum.BASKET}">
    <div class="reduce_and_add_count_button pointer flex_center_align_center" (click)="reduceCount()">
      <img src="assets/images/icons/ik_dekrement.svg">
    </div>
    <div class="count">
      {{productCard.countInBasket}}
    </div>
    <div class="reduce_and_add_count_button  flex_center_align_center pointer" (click)="addCount()">
      <img src="assets/images/icons/ik_add.svg">
    </div>
  </div>
  <div class="to_the_basket flex_center_align_center pointer"
       (click)="navigateToBasket()"
       [routerLink]="'basket'"
       *ngIf="type !== AddAndReduceStatusEnum.BASKET"
  >
    <img src="assets/images/icons/shopping_bag_check.svg">
    <span class="to_the_basket--text ml_12" >
      {{'buttons.to_the_basket' | translate}}
    </span>
  </div>
<!--  <div class="delete_button br_32 flex_center_align_center ml_12 pointer"-->
<!--       *ngIf="type!==addAndReduceStatusEnum.SINGLE_PAGE"-->
<!--       (click)="deleteFromBasket()">-->
<!--    <img src="assets/images/icons/trash.svg">-->
<!--  </div>-->
</div>
